/* Fann Bliss — occasion pages (Teacher's Day and the next ones).
   fann-occasion-bundles: set-size cards open a builder dialog; picks + optional names ride on the
   bundle product's cart line as properties (Mug 1, Mug 2… and a hidden _items list).
   fann-occasion-grid: colour / "Add a name" chips, live counts, "Show more". */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var phone = window.matchMedia ? matchMedia('(max-width: 639px)') : { matches: false };
  var wide = window.matchMedia ? matchMedia('(min-width: 900px)') : { matches: true };
  function FH() { return window.FannHome || {}; }
  function money(c) {
    var f = FH().money; if (f) return f(c);
    var a = c / 100; return 'AED ' + (a % 1 === 0 ? a : a.toFixed(2));
  }
  function tpl(s, map) { return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function num(el, k) { return parseInt(el.getAttribute('data-' + k), 10) || 0; }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function icon(name) {
    var paths = { x: '<path d="M6 6l12 12M18 6 6 18"/>' };
    return '<svg class="fh-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || '') + '</svg>';
  }
  function addToBag(items) {
    if (FH().addItems) return FH().addItems(items);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag'); return d; }); });
  }

  /* ------------------------------------------------------------------ builder */
  function initBuilder(sec) {
    if (sec.__fhOb) return; sec.__fhOb = true;
    var dlg = $('[data-fh-ob-dlg]', sec); if (!dlg) return;
    var D = function (k, d) { var v = dlg.getAttribute('data-' + k); return v == null || v === '' ? (d || '') : v; };
    var tiers = $$('[data-fh-ob-tier]', dlg).filter(function (b) { return !b.disabled; });
    if (!tiers.length) return;
    tiers.sort(function (a, b) { return num(a, 'qty') - num(b, 'qty'); });
    var items = $$('.fh-ob-item', dlg), byV = {};
    items.forEach(function (it) { byV[it.getAttribute('data-v')] = it; });
    var regEl = $('[data-fh-ob-regular]', sec), regular = regEl ? parseInt(regEl.textContent, 10) || 0 : 0;
    var picksEl = $('[data-fh-ob-picks]', dlg), countEl = $('[data-fh-ob-count]', dlg), barEl = $('[data-fh-ob-bar]', dlg);
    var totalEl = $('[data-fh-ob-total]', dlg), wasEl = $('[data-fh-ob-was]', dlg), addBtn = $('[data-fh-ob-add]', dlg);
    var hintEl = $('[data-fh-ob-hint]', dlg), upEl = $('[data-fh-ob-upsell]', dlg), upT = $('[data-fh-ob-upsell-t]', dlg), upGo = $('[data-fh-ob-upsell-go]', dlg);
    var titleEl = $('[data-fh-ob-title]', dlg), subEl = $('[data-fh-ob-sub]', dlg), subText = subEl ? subEl.textContent : '';
    var tray = $('[data-fh-ob-tray]', dlg), trayBtn = $('[data-fh-ob-traytoggle]', dlg), emptyEl = $('[data-fh-ob-empty]', dlg);
    var qIn = $('[data-fh-ob-q]', dlg), chips = $$('[data-fh-ob-chips] .fh-tab', dlg), body = $('[data-fh-ob-body]', dlg);
    var st = { tier: null, picks: [], f: 'all', q: '', uid: 0, wasFull: false };
    var rows = {}, subTimer;

    function qty() { return st.tier ? num(st.tier, 'qty') : 0; }
    function countOf(v) { var n = 0; st.picks.forEach(function (p) { if (p.v === v) n++; }); return n; }
    function say(msg, err) {
      if (!subEl) return;
      clearTimeout(subTimer); subEl.textContent = msg; subEl.classList.toggle('fh-err', !!err); subEl.classList.add('fh-say');
      subTimer = setTimeout(function () { subEl.textContent = subText; subEl.classList.remove('fh-err', 'fh-say'); }, err ? 6000 : 2800);
    }
    function setTier(btn, quiet) {
      st.tier = btn;
      tiers.forEach(function (t) { var on = t === btn; t.setAttribute('aria-checked', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      var q = qty();
      if (st.picks.length > q) { st.picks = st.picks.slice(0, q); if (!quiet) say(tpl(D('trimmed'), { q: q })); }
      render();
    }
    function add(v) {
      var it = byV[v]; if (!it) return;
      if (st.picks.length >= qty()) { render(); return; }
      if (countOf(v) >= (num(it, 'max') || 99)) return;
      st.picks.push({ id: ++st.uid, v: v, t: it.getAttribute('data-t') || '', cl: it.getAttribute('data-cl') || '', img: it.getAttribute('data-img') || '', name: it.getAttribute('data-name') === '1', val: '' });
      render();
      if (st.picks.length === qty() && !wide.matches && st.picks.some(function (p) { return p.name; })) openTray(true);
    }
    function removeLast(v) {
      for (var i = st.picks.length - 1; i >= 0; i--) { if (st.picks[i].v === v) { st.picks.splice(i, 1); break; } }
      render();
    }
    function removeId(id) { st.picks = st.picks.filter(function (p) { return p.id !== id; }); render(); }

    function row(p) {
      var li = el('li', 'fh-ob-pk'); li.setAttribute('data-id', p.id);
      var im = el('span', 'fh-ob-pk-img');
      if (p.img) { var img = document.createElement('img'); img.src = p.img; img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy'; im.appendChild(img); }
      var tx = el('div', 'fh-ob-pk-t');
      tx.appendChild(el('b', null, p.t));
      if (p.cl) tx.appendChild(el('span', null, p.cl));
      if (p.name) {
        var lab = el('label', 'fh-ob-nm');
        var ls = el('span', null, D('name-label') + ' '); ls.appendChild(el('em', null, D('optional'))); lab.appendChild(ls);
        var inp = document.createElement('input');
        inp.type = 'text'; inp.maxLength = parseInt(D('name-max', '20'), 10) || 20; inp.placeholder = D('name-ph');
        inp.autocomplete = 'off'; inp.setAttribute('autocapitalize', 'words'); inp.spellcheck = false; inp.setAttribute('enterkeyhint', 'next');
        inp.value = p.val;
        inp.addEventListener('input', function () { p.val = inp.value; });
        inp.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return; e.preventDefault();
          var all = $$('.fh-ob-nm input', picksEl), i = all.indexOf(inp);
          if (all[i + 1]) all[i + 1].focus(); else if (!addBtn.disabled) addBtn.focus(); else inp.blur();
        });
        lab.appendChild(inp); tx.appendChild(lab);
      }
      var rm = el('button', 'fh-ob-rm'); rm.type = 'button';
      rm.setAttribute('aria-label', D('remove') + ' ' + p.t + (p.cl ? ', ' + p.cl : ''));
      rm.innerHTML = icon('x');
      rm.addEventListener('click', function () {
        var next = li.nextElementSibling || li.previousElementSibling;
        removeId(p.id);
        var f = next && $('.fh-ob-rm', next); if (f) f.focus(); else if (trayBtn) trayBtn.focus();
      });
      li.appendChild(im); li.appendChild(tx); li.appendChild(rm);
      return li;
    }
    function renderPicks() {
      var keep = {};
      st.picks.forEach(function (p) { keep[p.id] = true; });
      Object.keys(rows).forEach(function (id) { if (!keep[id]) { rows[id].remove(); delete rows[id]; } });
      st.picks.forEach(function (p) {
        var r = rows[p.id];
        if (!r) { r = rows[p.id] = row(p); r.classList.add('fh-new'); setTimeout(function () { r.classList.remove('fh-new'); }, 400); }
        picksEl.appendChild(r); /* re-appending keeps DOM order = pick order */
      });
    }
    function render() {
      if (!st.tier) return;
      var q = qty(), p = st.picks.length, full = p >= q;
      items.forEach(function (it) {
        var v = it.getAttribute('data-v'), n = countOf(v), max = num(it, 'max') || 99;
        var nEl = $('[data-fh-ob-n]', it); if (nEl) nEl.textContent = n ? '×' + n : '';
        it.classList.toggle('fh-on', n > 0);
        var mi = $('[data-fh-ob-minus]', it); if (mi) mi.hidden = !n;
        var pl = $('[data-fh-ob-plus]', it), dis = full || n >= max;
        if (pl) pl.setAttribute('aria-disabled', dis ? 'true' : 'false');
        it.classList.toggle('fh-ob-dis', dis);
      });
      if (countEl) countEl.textContent = tpl(D('count-tpl'), { p: p, q: q });
      if (barEl) barEl.style.width = (q ? Math.min(100, p / q * 100) : 0) + '%';
      var total = num(st.tier, 'total'), was = regular * q;
      if (totalEl) totalEl.textContent = money(total);
      if (wasEl) wasEl.textContent = was > total ? money(was) : '';
      addBtn.disabled = !full;
      addBtn.textContent = full ? D('add-label') + ' · ' + money(total) : tpl(D('pick-more'), { n: q - p });
      if (titleEl) titleEl.textContent = D('set-name') + ' · ' + q + ' ' + D('units');
      renderPicks();
      if (hintEl) hintEl.hidden = p > 0;
      if (tray) { tray.classList.toggle('fh-full', full); tray.classList.toggle('fh-has', p > 0); }
      var next = tiers.filter(function (t) { return num(t, 'qty') > q; })[0];
      if (upEl) {
        upEl.hidden = !full;
        if (full && next) {
          upT.textContent = tpl(D('upsell'), { n: num(next, 'qty') - q, each: money(num(next, 'each')) });
          upGo.hidden = false; upGo.textContent = tpl(D('upsell-cta'), { q: num(next, 'qty') }); upGo.__t = next;
        } else if (full) { upT.textContent = D('full'); upGo.hidden = true; }
      }
      if (full && !st.wasFull) dlg.classList.add('fh-ob-pulse'), setTimeout(function () { dlg.classList.remove('fh-ob-pulse'); }, 700);
      st.wasFull = full;
    }

    /* filters */
    function counts() {
      var c = { all: 0, name: 0 };
      items.forEach(function (it) { c.all++; if (it.getAttribute('data-name') === '1') c.name++; var k = it.getAttribute('data-c'); if (k) c['c:' + k] = (c['c:' + k] || 0) + 1; });
      chips.forEach(function (ch) {
        var f = ch.getAttribute('data-f'), n = c[f] || 0, ne = $('[data-fh-n]', ch);
        if (ne) ne.textContent = n ? String(n) : '';
        ch.hidden = f !== 'all' && !n;
      });
    }
    function apply() {
      var shown = 0, q = st.q;
      items.forEach(function (it) {
        var f = st.f, okF = f === 'all' || (f === 'name' ? it.getAttribute('data-name') === '1' : 'c:' + it.getAttribute('data-c') === f);
        var okQ = !q || (it.getAttribute('data-q') || '').indexOf(q) > -1;
        it.hidden = !(okF && okQ); if (okF && okQ) shown++;
      });
      if (emptyEl) emptyEl.hidden = shown > 0;
      chips.forEach(function (ch) { ch.setAttribute('aria-pressed', ch.getAttribute('data-f') === st.f ? 'true' : 'false'); });
    }
    chips.forEach(function (ch) { ch.addEventListener('click', function () { st.f = ch.getAttribute('data-f'); apply(); if (body) body.scrollTop = 0; }); });
    if (qIn) qIn.addEventListener('input', function () { st.q = qIn.value.trim().toLowerCase(); apply(); });

    /* grid clicks */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { close(); return; }
      var plus = e.target.closest('[data-fh-ob-plus]'), minus = e.target.closest('[data-fh-ob-minus]');
      if (plus) {
        var it = plus.closest('.fh-ob-item');
        if (plus.getAttribute('aria-disabled') === 'true') {
          if (st.picks.length >= qty()) { say(D('full')); openTray(true); }
          return;
        }
        add(it.getAttribute('data-v'));
        it.classList.remove('fh-bump'); void it.offsetWidth; it.classList.add('fh-bump');
      } else if (minus) { removeLast(minus.closest('.fh-ob-item').getAttribute('data-v')); }
    });
    tiers.forEach(function (t, i) {
      t.addEventListener('click', function () { setTier(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0; if (!d) return;
        e.preventDefault(); var n = tiers[(i + d + tiers.length) % tiers.length]; setTier(n); n.focus();
      });
    });
    if (upGo) upGo.addEventListener('click', function () { if (upGo.__t) { setTier(upGo.__t, true); openTray(false); } });

    /* tray (phones: a bottom sheet that opens on demand) */
    function openTray(on) {
      if (!tray || wide.matches) return;
      tray.classList.toggle('fh-open', on);
      if (trayBtn) trayBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    if (trayBtn) trayBtn.addEventListener('click', function () { openTray(!tray.classList.contains('fh-open')); });
    function syncWide() {
      if (!trayBtn) return;
      if (wide.matches) { trayBtn.tabIndex = -1; trayBtn.removeAttribute('aria-expanded'); tray.classList.remove('fh-open'); }
      else { trayBtn.removeAttribute('tabindex'); trayBtn.setAttribute('aria-expanded', tray.classList.contains('fh-open') ? 'true' : 'false'); }
    }
    if (wide.addEventListener) wide.addEventListener('change', syncWide);
    syncWide();

    /* open / close */
    function open(tier) {
      setTier(tier || tiers[0], true);
      openTray(false);
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
      document.documentElement.classList.add('fh-ob-lock');
    }
    function close() { if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); document.documentElement.classList.remove('fh-ob-lock'); }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('fh-ob-lock'); });
    $$('[data-fh-ob-close]', dlg).forEach(function (b) { b.addEventListener('click', close); });
    function tierById(id) { return tiers.filter(function (t) { return t.getAttribute('data-fh-ob-tier') === id; })[0]; }
    function tierByQty(q) { return tiers.filter(function (t) { return num(t, 'qty') === q; })[0]; }
    $$('[data-fh-ob-open]', sec).forEach(function (b) {
      b.addEventListener('click', function () { var t = tierById(b.getAttribute('data-fh-ob-open')); if (t) open(t); });
    });
    sec.__fhObOpen = function (q) { var t = tierByQty(q) || tiers[0]; open(t); };

    /* add the set */
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled || addBtn.getAttribute('aria-busy') === 'true') return;
      var t = st.tier, q = qty(), props = {};
      props[D('prop-set')] = D('set-name') + ' · ' + q + ' ' + D('units');
      st.picks.forEach(function (p, i) {
        var line = p.t + (p.cl ? ' · ' + p.cl : ''), v = String(p.val || '').replace(/\s+/g, ' ').trim();
        if (v) line += ' · ' + D('prop-name') + ': ' + v;
        props[D('prop-item') + ' ' + (i + 1)] = line;
      });
      props._items = st.picks.map(function (p) { return p.v; }).join(',');
      addBtn.setAttribute('aria-busy', 'true');
      addToBag([{ id: num(t, 'variant'), quantity: 1, properties: props }]).then(function (r) {
        addBtn.removeAttribute('aria-busy');
        st.picks = []; rows = {}; picksEl.innerHTML = ''; render(); close();
        var first = r && r.added && (r.added.items ? r.added.items[0] : r.added);
        if (FH().toast) FH().toast(tpl(D('added'), { set: D('set-name'), q: q }), first && first.image ? first.image : null, { link: (FH().config && FH().config.routes && FH().config.routes.cart) || '/cart', linkText: 'View bag' });
      }).catch(function (err) {
        addBtn.removeAttribute('aria-busy');
        say((err && err.message) || 'Could not add to bag', true);
      });
    });

    counts(); apply();
    setTier(tiers.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0] || tiers[0], true);
  }

  function fromHash() {
    var m = /^#build-(\d+)$/.exec(location.hash || ''); if (!m) return;
    var sec = $('[data-fh-ob]'); if (sec && sec.__fhObOpen) sec.__fhObOpen(parseInt(m[1], 10));
  }

  /* --------------------------------------------------------------------- grid */
  function initGrid(sec) {
    if (sec.__fhOg) return; sec.__fhOg = true;
    var chips = $$('[data-fh-og-chips] .fh-tab', sec), items = $$('.fh-og-item', sec);
    var more = $('[data-fh-og-more]', sec), moreLab = more && $('[data-fh-morelabel]', more), empty = $('[data-fh-og-empty]', sec);
    var visM = num(sec, 'visible-m') || 8, visD = num(sec, 'visible-d') || 12, moreTpl = sec.getAttribute('data-more-label') || 'Show [n] more';
    var st = { f: 'all', open: false };
    function ok(it) {
      var f = st.f; return f === 'all' || (f === 'name' ? it.getAttribute('data-name') === '1' : 'c:' + it.getAttribute('data-c') === f);
    }
    (function counts() {
      var c = { all: items.length, name: 0 };
      items.forEach(function (it) { if (it.getAttribute('data-name') === '1') c.name++; var k = it.getAttribute('data-c'); if (k) c['c:' + k] = (c['c:' + k] || 0) + 1; });
      chips.forEach(function (ch) { var f = ch.getAttribute('data-f'), n = c[f] || 0, ne = $('[data-fh-n]', ch); if (ne) ne.textContent = n ? String(n) : ''; ch.hidden = f !== 'all' && !n; });
    })();
    function render(anim) {
      var lim = phone.matches ? visM : visD, shown = 0, match = 0;
      items.forEach(function (it) { var m = ok(it); if (m) match++; var v = m && (st.open || shown < lim); if (v) shown++; it.hidden = !v; });
      if (more) { var rest = match - shown; more.hidden = rest <= 0; if (moreLab) moreLab.textContent = tpl(moreTpl, { n: rest }); }
      if (empty) empty.hidden = match > 0;
      chips.forEach(function (ch) { ch.setAttribute('aria-pressed', ch.getAttribute('data-f') === st.f ? 'true' : 'false'); });
      if (anim) { var g = $('[data-fh-og-grid]', sec); if (g) { g.classList.remove('fh-og-fade'); void g.offsetWidth; g.classList.add('fh-og-fade'); } }
    }
    chips.forEach(function (ch) { ch.addEventListener('click', function () { st.f = ch.getAttribute('data-f'); st.open = false; render(true); }); });
    if (more) more.addEventListener('click', function () { st.open = true; render(false); });
    if (phone.addEventListener) phone.addEventListener('change', function () { render(false); });
    render(false);
  }

  function boot(scope) {
    $$('[data-fh-ob]', scope || document).forEach(initBuilder);
    $$('[data-fh-og]', scope || document).forEach(initGrid);
  }
  function start() { boot(); fromHash(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('hashchange', fromHash);
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    $$('[data-fh-ob]', e.target).forEach(function (s) { s.__fhOb = false; });
    $$('[data-fh-og]', e.target).forEach(function (s) { s.__fhOg = false; });
    boot(e.target);
  });
})();
